var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _ellipse, _g, _rect6, _path21, _rect7, _rect8, _rect9, _circle, _circle2, _path22, _circle3, _circle4, _circle5, _path23, _path24, _circle6, _circle7, _circle8, _circle9, _path25, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreasure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 213,
    viewBox: "0 0 248 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.639 52.2087L128.871 46.7424L123.21 49.619L117.742 46.3861L120.619 52.0483L117.387 57.5152L123.049 54.6381L128.515 57.8705L125.639 52.2087Z",
    fill: "url(#paint0_linear_585_14016)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.412 101.42L232.724 92.4368L223.421 97.164L214.436 91.8512L219.164 101.156L213.852 110.14L223.157 105.412L232.139 110.724L227.412 101.42Z",
    fill: "url(#paint1_linear_585_14016)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7922 28.5941L77.0384 14.6493L62.596 21.9875L48.6492 13.7401L55.9885 28.1847L47.7415 42.1307L62.1866 34.7912L76.1306 43.0369L68.7922 28.5941Z",
    fill: "url(#paint2_linear_585_14016)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.119 88.3494L122.768 80.4866L114.625 84.6243L106.761 79.974L110.899 88.1186L106.249 95.9822L114.394 91.8437L122.257 96.4931L118.119 88.3494Z",
    fill: "url(#paint3_linear_585_14016)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0374 74.51L62.3629 70.5774L58.29 72.6469L54.357 70.3212L56.4267 74.3946L54.1011 78.3274L58.1745 76.2576L62.1069 78.583L60.0374 74.51Z",
    fill: "url(#paint4_linear_585_14016)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.812 35.0638L182.137 31.1311L178.064 33.2006L174.131 30.8749L176.201 34.9483L173.875 38.8811L177.949 36.8114L181.881 39.1368L179.812 35.0638Z",
    fill: "url(#paint5_linear_585_14016)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1486 118.583C62.9978 103.252 60.4521 92.1878 56.8276 88.7753H75.562C78.4081 90.0375 81.9797 98.1104 82.7563 118.583H64.1486Z",
    fill: "#6C7393"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.655 118.583C185.806 103.252 188.351 92.1878 191.976 88.7753H173.241C170.395 90.0375 166.824 98.1104 166.047 118.583H184.655Z",
    fill: "#6C7393"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.2666,
    y: 91.5333,
    width: 127.562,
    height: 10.3429,
    fill: "#C4C7D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.2666,
    y: 101.876,
    width: 127.562,
    height: 15.859,
    fill: "#D3D4DF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.2666,
    y: 180.482,
    width: 127.562,
    height: 15.859,
    fill: "#D3D4DF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 61.2666,
    y: 117.735,
    width: 127.562,
    height: 15.859,
    fill: "#E2E2E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61.2666,
    y: 164.623,
    width: 127.562,
    height: 15.859,
    fill: "#E2E2E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.295 202.753C49.7981 199.373 52.4174 196.341 55.8331 196.341H192.883C196.363 196.341 199 199.484 198.395 202.911L196.756 212.2H51.6844L50.295 202.753Z",
    fill: "url(#paint6_linear_585_14016)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7466 88.7753C67.1496 96.8309 64.5938 147.534 72.2613 196.341H55.2998C44.1469 115.785 51.7371 91.0656 56.9262 88.7753H75.7466Z",
    fill: "url(#paint7_linear_585_14016)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.969 88.7753C181.566 96.8309 184.122 147.534 176.455 196.341H193.416C204.569 115.785 196.979 91.0656 191.79 88.7753H172.969Z",
    fill: "url(#paint8_linear_585_14016)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.288 88.7753C181.846 96.8326 184.39 147.546 176.757 196.364C182.562 146.026 179.779 114.188 176.255 98.3651C175.444 95.2402 174.096 91.777 173.266 91.5695L173.499 90.638L174.197 91.1037L174.268 91.1981C173.933 90.2506 173.604 89.4437 173.288 88.7753Z",
    fill: "#6C7393"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4358 88.7753C66.8781 96.8326 64.3339 147.546 71.9664 196.364C66.1615 146.023 68.9453 114.183 72.4693 98.362C73.2803 95.2379 74.6279 91.777 75.4578 91.5695L75.2249 90.638L74.5263 91.1037L74.4557 91.1978C74.7911 90.2505 75.12 89.4437 75.4358 88.7753Z",
    fill: "#6C7393"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.718 138.593C44.718 135.452 47.224 132.905 50.3153 132.905H197.711C200.802 132.905 203.308 135.452 203.308 138.593V148.074H44.718V138.593Z",
    fill: "#B6B9C9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6509 148.764H202.376L203.308 148.074H44.718L45.6509 148.764Z",
    fill: "#414558"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2628 195.651H176.919L192.966 196.341H55.7505L72.2628 195.651Z",
    fill: "#575C75"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2598 132.215H181.01L197.792 132.905H49.5447L67.2598 132.215Z",
    fill: "#6C7393"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6509 148.764H202.376L203.308 149.453H44.718L45.6509 148.764Z",
    fill: "#21263F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51 159.4L198 159L195.993 169H52.5051L51 159.4Z",
    fill: "#414558"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.718 158.934C44.718 162.076 47.224 164.623 50.3153 164.623H197.711C200.802 164.623 203.308 162.076 203.308 158.934V149.453H44.718V158.934Z",
    fill: "#8A8FA8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 124,
    cy: 148,
    rx: 124,
    ry: 15,
    fill: "url(#paint9_radial_585_14016)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_585_14016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 149L203 148",
    stroke: "url(#paint10_linear_585_14016)",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 126.082,
    y: 148.074,
    width: 8.96381,
    height: 3.44762,
    rx: 1.72381,
    transform: "rotate(90 126.082 148.074)",
    fill: "#191C2E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.05 141.49C115.05 140.937 115.497 140.49 116.05 140.49H131.977C132.529 140.49 132.977 140.937 132.977 141.49V157.675C132.977 159.608 131.41 161.175 129.477 161.175H118.55C116.617 161.175 115.05 159.608 115.05 157.675V141.49Z",
    fill: "#21263F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 114.36,
    y: 139.8,
    width: 4.82667,
    height: 1.37905,
    rx: 0.5,
    fill: "#6C7393"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 121.755,
    y: 139.8,
    width: 4.82667,
    height: 1.37905,
    rx: 0.5,
    fill: "#6C7393"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 129.59,
    y: 139.8,
    width: 4.13714,
    height: 1.37905,
    rx: 0.5,
    fill: "#6C7393"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 125.737,
    cy: 172.553,
    r: 12.7562,
    fill: "url(#paint11_linear_585_14016)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.358,
    cy: 159.452,
    r: 7.24,
    fill: "url(#paint12_linear_585_14016)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.257 161.775C116.966 160.939 116.82 160.038 116.849 159.101C116.974 154.987 120.411 151.754 124.525 151.879C128.639 152.005 131.872 155.441 131.746 159.555C131.711 160.712 131.414 161.799 130.913 162.762C130.454 162.32 129.955 161.919 129.422 161.564C129.699 160.929 129.862 160.233 129.884 159.498C129.978 156.413 127.553 153.836 124.468 153.741C121.383 153.647 118.805 156.072 118.711 159.158C118.694 159.728 118.762 160.28 118.905 160.803C118.326 161.078 117.774 161.404 117.257 161.775Z",
    fill: "#B6B9C9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.362,
    cy: 170.856,
    r: 10.7123,
    fill: "#575C75"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.431,
    cy: 170.391,
    r: 10.7123,
    fill: "url(#paint13_linear_585_14016)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.431,
    cy: 170.39,
    r: 9.53083,
    stroke: "#414558",
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M126.225 168.061C126.225 169.605 124.974 170.856 123.431 170.856C121.887 170.856 120.636 169.605 120.636 168.061C120.636 166.518 121.887 165.267 123.431 165.267C124.974 165.267 126.225 166.518 126.225 168.061Z",
    fill: "#21263F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M122.383 169.226H124.362L125.322 174.412C125.429 174.985 124.989 175.513 124.407 175.513H122.434C121.859 175.513 121.421 174.997 121.515 174.429L122.383 169.226Z",
    fill: "#21263F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.485,
    cy: 170.157,
    r: 1.39726,
    fill: "#21263F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.376,
    cy: 170.157,
    r: 1.39726,
    fill: "#21263F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.485,
    cy: 170.157,
    r: 0.698631,
    fill: "#11E4CB"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.376,
    cy: 170.157,
    r: 0.698631,
    fill: "#11E4CB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.933 161.873C116.617 161.047 116.444 160.15 116.444 159.212C116.444 155.097 119.781 151.76 123.896 151.76C128.012 151.76 131.348 155.097 131.348 159.212C131.348 160.37 131.085 161.466 130.614 162.443C130.141 162.016 129.63 161.63 129.086 161.291C129.344 160.648 129.485 159.947 129.485 159.212C129.485 156.126 126.983 153.623 123.896 153.623C120.81 153.623 118.307 156.126 118.307 159.212C118.307 159.783 118.393 160.333 118.552 160.851C117.98 161.144 117.439 161.486 116.933 161.873Z",
    fill: "#E2E2E9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 125.393,
    y: 147.385,
    width: 10.3429,
    height: 2.75809,
    rx: 1.37905,
    transform: "rotate(90 125.393 147.385)",
    fill: "url(#paint14_linear_585_14016)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 1,
    transform: "matrix(-1 0 0 1 133.6 95)",
    fill: "#B6B9C9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 1,
    transform: "matrix(-1 0 0 1 68.6001 91)",
    fill: "#8A8FA8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    transform: "matrix(-1 0 0 1 62.3501 93)",
    fill: "#8A8FA8"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    transform: "matrix(-1 0 0 1 57.3501 95)",
    fill: "#8A8FA8"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 185.6,
    y: 125.25,
    width: 12,
    height: 1,
    fill: "#6C7393"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 190.6,
    y: 127.25,
    width: 7,
    height: 1,
    fill: "#6C7393"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 194.6,
    y: 129.25,
    width: 3,
    height: 1,
    fill: "#6C7393"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 1,
    transform: "matrix(-1 0 0 1 110.6 205.75)",
    fill: "#6C7393"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 1,
    transform: "matrix(-1 0 0 1 192.35 199)",
    fill: "#6C7393"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_585_14016",
    x: 39.5,
    y: 142.5,
    width: 169,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_585_14016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_585_14016",
    x1: 123.878,
    y1: 45.2522,
    x2: 121.611,
    y2: 58.1634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBEAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_585_14016",
    x1: 224.52,
    y1: 89.9877,
    x2: 220.793,
    y2: 111.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBEAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_585_14016",
    x1: 64.302,
    y1: 10.8474,
    x2: 58.5172,
    y2: 43.7842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBEAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_585_14016",
    x1: 115.587,
    y1: 78.3429,
    x2: 112.325,
    y2: 96.9145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBEAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_585_14016",
    x1: 58.7712,
    y1: 69.5053,
    x2: 57.1399,
    y2: 78.7937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBEAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_585_14016",
    x1: 178.545,
    y1: 30.059,
    x2: 176.914,
    y2: 39.3474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBEAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_585_14016",
    x1: 121.6,
    y1: 225,
    x2: 121.6,
    y2: 204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8FA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_585_14016",
    x1: 67.7924,
    y1: 100.882,
    x2: 43.2132,
    y2: 187.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C7393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_585_14016",
    x1: 180.924,
    y1: 100.882,
    x2: 205.503,
    y2: 187.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C7393"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_585_14016",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124 148) scale(103.5 12.5202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DFFCF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEFD9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_585_14016",
    x1: 127,
    y1: 186,
    x2: 126.502,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEFD9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492568,
    stopColor: "#2EEFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEFD9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_585_14016",
    x1: 135.942,
    y1: 181.482,
    x2: 125.099,
    y2: 168.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C7393",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_585_14016",
    x1: 120.388,
    y1: 158.284,
    x2: 128.796,
    y2: 163.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10121E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C7393",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_585_14016",
    x1: 133.1,
    y1: 176.5,
    x2: 94.6001,
    y2: 159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C7393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_585_14016",
    x1: 125.393,
    y1: 150.603,
    x2: 125.393,
    y2: 146.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8FA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C7D4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasure);
export default __webpack_public_path__ + "static/media/treasure.669d7c866fe6a05520fce17d56a0e803.svg";
export { ForwardRef as ReactComponent };